import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

export type IssuesLog = {
  removedPaths: string[];
  mismatchedPaths: string[];
};

export function SchemaIssuesAlert(props: {
  log: IssuesLog | null;
  title?: string;
  description?: string;
  onDismiss?: () => void;
  className?: string;
}) {
  const { log, title = 'Lost or mismatched data', description, onDismiss, className } = props;

  const hasRemoved = (log?.removedPaths?.length ?? 0) > 0;
  const hasMismatched = (log?.mismatchedPaths?.length ?? 0) > 0;

  if (!hasRemoved && !hasMismatched) return null;

  if (!log) return null;

  return (
    <Card className={['rounded-2xl border-yellow-300 bg-yellow-50', className ?? ''].join(' ')}>
      <CardHeader>
        <CardTitle className="text-yellow-900">{title}</CardTitle>
        {description ? <CardDescription className="text-yellow-800">{description}</CardDescription> : null}
      </CardHeader>

      <CardContent className="space-y-3 text-sm">
        {hasRemoved ? (
          <div>
            <div className="font-medium text-yellow-900">Removed fields:</div>
            <ul className="list-disc pl-5 text-yellow-900">
              {log.removedPaths.map((p) => (
                <li key={p}>
                  <code>{p}</code>
                </li>
              ))}
            </ul>
          </div>
        ) : null}

        {hasMismatched ? (
          <div>
            <div className="font-medium text-yellow-900">Mismatched fields:</div>
            <ul className="list-disc pl-5 text-yellow-900">
              {log.mismatchedPaths.map((p) => (
                <li key={p}>
                  <code>{p}</code>
                </li>
              ))}
            </ul>
          </div>
        ) : null}

        {onDismiss ? (
          <div className="flex justify-end">
            <Button type="button" size="sm" variant="outline" onClick={onDismiss}>
              Dismiss
            </Button>
          </div>
        ) : null}
      </CardContent>
    </Card>
  );
}
